// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IDocumentProofApi,
  IDocumentProofApiRequest,
  IDocumentProofApiGetResponse,
  IDocumentProofApiGetAllAttrs,
  IDocumentProofApiSaveAttrs,
  IDocumentProofApiGetAllResponse,
  IDocumentProofApiGetDropdownAttrs,
  IDocumentProofApiGetDropdownResponse,
  IDocumentProofApiGetAttrs,
} from 'interfaces/back-office/master/document-proof/document-proof-api.interface'
// eslint-disable-next-line
import { IBaseApiRequestPayload } from 'interfaces/api'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class DocumentProofApi extends BaseApi<IDocumentProofApi> implements IDocumentProofApiRequest {
  readonly url = ApiConstant.MASTER_DOCUMENT_PROOF_URL
  private documentProofUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get Document Proofs
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IDocumentProofApiGetAllAttrs} payload
   *
   * @return {Promise<IDocumentProofApiGetAllResponse>} Promise<IDocumentProofApiGetAllResponse>
   */
  async documentProof_getDocumentProofs(payload: IDocumentProofApiGetAllAttrs): Promise<IDocumentProofApiGetAllResponse> {
    try {
      const response = await this.POST(`${this.documentProofUrl}/list`, { ...payload.body }, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get Document Proof
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IDocumentProofApiGetAttrs} payload
   *
   * @return {Promise<IDocumentProofApiGetResponse>} Promise<IDocumentProofApiGetResponse>
   */
  async documentProof_getDocumentProof(payload: IDocumentProofApiGetAttrs): Promise<IDocumentProofApiGetResponse> {
    try {
      const response = await this.POST(`${this.documentProofUrl}/${payload.params.id}`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Save Document Proof
   *
   * @method POST
   * @url TBD
   * @access private (only user that logged in)
   *
   * @param {IDocumentProofApiSaveAttrs} payload
   *
   * @return {Promise<IDocumentProofApiGetResponse>} Promise<IDocumentProofApiGetResponse>
   */
  async masterDocumentProof_saveDocumentProof(payload: IDocumentProofApiSaveAttrs): Promise<IDocumentProofApiGetResponse> {
    try {
      const requestPayload: IBaseApiRequestPayload = {
        method: 'POST',
        url: payload.params?.id ? `${this.documentProofUrl}/update/${payload.params.id}` : `${this.documentProofUrl}/create`,
      }
      const response = await this[requestPayload.method](requestPayload.url, payload.body, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }

  /**
   * @description Get document-proof dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IDocumentProofApiGetDropdownAttrs} payload
   *
   * @return {Promise<IDocumentProofApiGetDropdownResponse>} Promise<IDocumentProofApiGetDropdownResponse>
   */
  async documentProof_getDocumentProofDropdown(
    payload: IDocumentProofApiGetDropdownAttrs,
  ): Promise<IDocumentProofApiGetDropdownResponse> {
    try {
      const response = await this.POST(`${this.documentProofUrl}/dropdown`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
